import { render, staticRenderFns } from "./authorize.vue?vue&type=template&id=19ea8622&scoped=true&"
import script from "./authorize.vue?vue&type=script&lang=js&"
export * from "./authorize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ea8622",
  null
  
)

export default component.exports